import Vue from 'vue';
import Vuex from 'vuex';
import config from './modules/config';
import printers from './modules/printers';
import products from './modules/products';
import orders from './modules/orders';
import registration from './modules/registration';
import promotions from './modules/promotions';
import prices from './modules/prices';
import files from './modules/files';
import view from './modules/view';
import auth from './modules/auth';
import statistics from './modules/statistics';
import layouts from './modules/layouts';
import setup from './modules/setup';
import templates from './modules/templates';
import dragAndDrop from './modules/dragAndDrop';
import backto from './modules/backto';
import userData from './modules/userData';
import shops from './modules/shops';
import shopsViewStore from './modules/shopsViewStore';
import users from './modules/users';
import table from './modules/table';
import backuper from './modules/backuper';
import notifications from './modules/notifications';
import testmoni from './modules/testmoni';
import accountTerms from './modules/accountTerms';
import banners from './modules/banners';
import taskmanager from './modules/taskmanager';
import loadbalancer from './modules/loadbalancer';
import documents from './modules/documents';
import devices from './modules/devices';
import payment from './modules/payment';

Vue.use(Vuex);

/**
 * @module Store
 * @type {object}
 * @property {object} modules - modules injected into store instance
 * @description This is the main configuration file for Store instance coming from Vuex
 */
export const store = new Vuex.Store({
    modules: {
        table,
        config,
        printers,
        files,
        products,
        orders,
        registration,
        statistics,
        prices,
        promotions,
        auth,
        templates,
        view,
        layouts,
        setup,
        dragAndDrop,
        backto,
        userData,
        shops,
        users,
        backuper,
        notifications,
        testmoni,
        accountTerms,
        banners,
        taskmanager,
        loadbalancer,
        documents,
        devices,
        shopsViewStore,
        payment
    }
});
